
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { from } from 'rxjs';
import { MatTableDataSource} from '@angular/material/table'


export interface Computerparts {
  Inputdevices: string;
  position: number;
  Outputdevices: string;
Storagedevices: string;
}

const Computer_DATA: Computerparts[] = [



  
  {position: 1, Inputdevices: 'Keyboards', Outputdevices: 'Monitor', Storagedevices: 'Hard disk drive'},
  {position: 2, Inputdevices: 'Pointing devices', Outputdevices: 'Printers', Storagedevices: 'Magnetic tape'},
  {position: 3, Inputdevices: 'Joystick', Outputdevices: 'Projectors', Storagedevices: 'CD Roms'},
  {position: 4, Inputdevices: 'Touchscreen', Outputdevices: 'Plotters', Storagedevices: 'DVD Rom'},
  {position: 5, Inputdevices: 'Scanners', Outputdevices: 'Speakers', Storagedevices: 'Blu ray'},
  {position: 6, Inputdevices: 'Sensors', Outputdevices: 'Headphones', Storagedevices: 'Memory-stick'},
  {position: 7, Inputdevices: 'Remote control', Outputdevices: 'Inkjet printers', Storagedevices: 'Pen drive'},
  {position: 8, Inputdevices: 'Digital cameras', Outputdevices: 'Laser printers', Storagedevices: 'DVD Ram'},
  {position: 9, Inputdevices: 'Microphone', Outputdevices: '3D printers', Storagedevices: 'SD cards'},
  {position: 10, Inputdevices: 'Graphics tablet', Outputdevices: 'Dot matrix printers', Storagedevices: 'Flash memory card'},
];







@Component({
  selector: 'app-hardware',
  templateUrl: './hardware.component.html',
  styleUrls: ['./hardware.component.css']
})
export class HardwareComponent implements OnInit {
  displayedColumns: string[] = ['position', 'Inputdevices', 'Outputdevices', 'Storagedevices'];
  dataSource = new MatTableDataSource (Computer_DATA);
    


  constructor() { }

  ngOnInit(): void {
  }

  applyFilter (filterValue: string){
    this.dataSource.filter = filterValue.trim() .toLowerCase();
  }


}
